import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../Assets/Css/about.css';
import aboutimg1 from '../Assets/Image/aboutimg1.jpg';
import aboutimg2 from '../Assets/Image/aboutimg2.jpg';
import aboutimg3 from '../Assets/Image/aboutimg3.jpg';
import aboutimg4 from '../Assets/Image/aboutimg4.jpg';
import drone from '../Assets/Image/droneimage.jpeg';
import { FaLeaf, FaMicroscope, FaShieldAlt} from 'react-icons/fa';
import { Helmet } from 'react-helmet';
///import sucessstory from '../Assets/Images/sumadhurhoneyimg3.jpg';
//import backvideo from '../Assets/Images/hobeybeevideo1.mp4';



export default function About() {
  return (
    <>
      <div>
        <Helmet>
        <title>About Us | Sense Technologies, Inc.</title>
        <meta name="description" content="Learn about Sense Technologies, Inc. — a forward-thinking R&D company behind Sense Natural Products, driving innovation in agriculture, nutrition, and sensing systems." />
        <meta name="keywords" content="Sense Technologies, Sense Natural Products, sustainable R&D, biosensors, agriculture, precision technology, naturally-sourced innovations" />
        <meta name="author" content="Sense Technologies, Inc." />
        
        {/* Open Graph for social sharing */}
        <meta property="og:title" content="About Us | Sense Technologies, Inc." />
        <meta property="og:description" content="Delivering innovative, sustainable solutions through biosensors, agriculture, and natural technologies. Backed by science, inspired by nature." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sensenaturalproducts.com/about" />
        <meta property="og:image" content="https://sensenaturalproducts.com/images/og-about.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:title" content="About Us | Sense Technologies, Inc." />
        <meta name="twitter:description" content="Fusing advanced R&D with nature's purity for sustainable innovation in agriculture and wellness." />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://sensenaturalproducts.com/images/twitter-about.jpg" />

        <link rel="canonical" href="https://sensenaturalproducts.com/about" />
      </Helmet>
        <Container className="my-4">
          <Card className="border-0 p-3">
            <div>
              <h2 className="Mainhead mb-4">About Us</h2>
            </div>

            <Row>
              {/* Images on the left */}
              <Col lg={6} sm={6}>
                <Row className="text-center mb-2">
                  <Col lg={6} sm={6} className="mb-3">
                    <img
                      src={aboutimg1}
                      alt="sense tech. 1"
                      className="img-fluid rounded shadow img-hover-effect"
                      style={{ width: '400px', height: '200px', objectFit: 'cover' }}
                    />
                  </Col>
                  <Col lg={6} sm={6} className="mb-3">
                    <img
                      src={aboutimg2}
                      alt="sense tech. 2"
                      className="img-fluid rounded shadow img-hover-effect"
                      style={{  width: '400px', height: '200px', objectFit: 'cover' }}
                    />
                  </Col>
                  <Col lg={6} sm={6} className="mb-3">
                    <img
                      src={aboutimg3}
                      alt="sense tech. 3"
                      className="img-fluid rounded shadow img-hover-effect"
                      style={{  width: '400px', height: '200px', objectFit: 'cover' }}
                    />
                  </Col>
                  <Col lg={6} sm={6} className="mb-3">
                    <img
                      src={aboutimg4}
                      alt="sense tech. 4"
                      className="img-fluid rounded shadow img-hover-effect"
                      style={{  width: '400px', height: '200px', objectFit: 'cover' }}
                    />
                  </Col>
                  
                </Row>
              </Col>

              {/* Text on the right */}
              <Col lg={6} sm={12} style={{ textAlign: 'justify' }}>
                <p>
                <strong>At Sense Technologies,</strong> innovation isn’t just a goal—it’s our foundation. Our interdisciplinary team brings together experts in engineering, biology, and sustainable development to design technologies that solve real-world problems. Whether it’s improving precision in agricultural monitoring or extracting high-purity proteins from natural sources, our work is always rooted in science, driven by purpose.
                </p>
                <p>
                  We believe that technology should work in harmony with nature, not against it. That’s why our development process prioritizes renewable resources, energy-efficient manufacturing, and biodegradable materials wherever possible. From radar-based environmental sensing to clean protein extrusion methods, each of our innovations is designed to minimize impact while maximizing benefits for people and planet.
                </p>
                <p>
                  Sense Technologies thrives on collaboration. We actively partner with farmers, researchers, and industry leaders to ensure our solutions are practical, adaptable, and scalable. By staying connected to the communities and ecosystems we serve, we continue to refine our technologies and expand our impact—one meaningful solution at a time.
                </p>
                
              </Col>
            </Row>
          </Card>

         </Container>

      

          <Container className="position-relative z-1">
            <div className="text-center mb-4">
              <h2 className="Mainhead2 mb-3">Excellence Through Nature & Technology</h2>
              <p className="text-white">Purity. Precision. Purpose .</p>
            </div>
            <Row className="text-center">
              <Col lg={4} sm={12} className="mb-4">
                <div className="feature-box p-4 h-100 rounded shadow text-dark bg-white">
                   <FaMicroscope size={40} color="#007bff" className="mb-3" />
                  <h5 className="mb-2">Backed by Science, Inspired by Nature</h5>
                  <p>Fusing advanced R&D with natural purity for real-world impact.</p>
                </div>
              </Col>

              <Col lg={4} sm={12} className="mb-4">
                <div className="feature-box p-4 h-100 rounded text-dark shadow bg-white">
                   <FaLeaf size={40} color="#28a745" className="mb-3" />
                  <h5 className="mb-2">Sustainable to the Core</h5>
                  <p>Built with renewable resources and eco-conscious practices.</p>
                </div>
              </Col>

              <Col lg={4} sm={12} className="mb-4">
                <div className="feature-box p-4 h-100 rounded text-dark shadow bg-white">
                   <FaShieldAlt size={40} color="#007bff" className="mb-3" />
                  <h5 className="mb-2"> Quality You Can Trust</h5>
                  <p>All products undergo rigorous testing and quality assurance to ensure purity, performance, and impact.</p>
                </div>
              </Col>
              
            </Row>
          </Container>
        {/* </Card> */}

        {/* Commitment to Quality Section */}
        <Container>
           {/* <Col lg={6} sm={6} className="mb-3">
                    <img
                      src={drone}
                      alt="sense tech. 5"
                      className="img-fluid rounded shadow img-hover-effect"
                      style={{  width: '400px', height: '200px', objectFit: 'cover' }}
                    />
                  </Col> */}
          <Card className="border-0 p-3 mt-2">
            <div className="text-center mb-4">
              <h2 className="Mainhead mb-3">Our Commitment to Quality</h2>
              <p className="section-subtitle">Delivering Precision with Every Innovation</p>
            </div>
            <Row>
              <Col lg={6} sm={12} className="mb-4 mb-lg-0">
                <div className="d-flex justify-content-center">
                  <img
                    src={drone}
                    alt="Commitment to Quality"
                    className="img-fluid rounded shadow"
                    style={{ width: '400px', height: '300px', objectFit: 'cover' }}
                  />
                </div>
              </Col>
              <Col lg={6} sm={12}>
                <p style={{ textAlign: 'justify' }}>
                  At <strong>Sense Technologies, Inc.</strong>,quality is not just a standard—it’s our foundation. From advanced research to product delivery, every step is governed by rigorous scientific validation and environmental responsibility.
                  <br /><br />
                  We work closely with certified partners and experts who follow Every solution reflects our promise to combine <strong>sustainable, chemical-free, and transparent practices.</strong>,
                  Whether it’s a precision biosensor or a natural health product, we ensure that what reaches our users is <strong>safe, effective, and environmentally sound. </strong>
                     <br /><br />
                     Every solution reflects our promise to combine <strong> cutting-edge science with nature’s intelligence—</strong>building a healthier, smarter, and more sustainable future.
                </p>
              </Col>
            </Row>
          </Card>
        </Container>
      </div>
    </>
  );
}
